import React, { memo, useCallback, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import { Box, Flex, useBreakpointValue, useColorModeValue } from "@chakra-ui/react"

/* Components */
import { Footer, Header } from "@/components"

/* Content */
import content from "@/content.json"

const AppContainer = memo(({ setChangeMode, children }) => {
    /* Color Management */
    const bgColor = useColorModeValue("white", "gray.800")
    const contentBgColor = useColorModeValue("gray.50", "gray.900")
    const [systemColorMode, setSystemColorMode] = useState("light")
    const viewport = useBreakpointValue({ base: "mobile", lg: "desktop" })

    /* Content */
    const siteName = content.heading
    const siteDesc = content.subheading

    const onSystemColorModeChange = useCallback(({ matches }) => {
        setSystemColorMode(matches ? "dark" : "light")
    }, [])

    useEffect(() => {
        if (typeof window !== "undefined") {
            const mq = window.matchMedia("(prefers-color-scheme: dark)")
            mq.addEventListener("change", onSystemColorModeChange)
            onSystemColorModeChange(mq)
        }
        return () => {
            window
                .matchMedia("(prefers-color-scheme: dark)")
                .removeEventListener("change", onSystemColorModeChange)
        }
    })

    return (
        <>
            <Helmet>
                <meta name="description" content={siteDesc} key="site-desc" />
                <title>{siteName}</title>
            </Helmet>
            <Flex
                bgColor={bgColor}
                direction="column"
                minHeight="100vh"
                pt={viewport === "mobile" ? "72px" : 0}
            >
                <Header
                    bgColor={bgColor}
                    boxShadow={viewport === "mobile" ? "sm" : "none"}
                    title={siteName}
                    description={siteDesc}
                    position={viewport === "mobile" ? "fixed" : "relative"}
                    top={0}
                    w="full"
                    zIndex={1}
                    setChangeMode={setChangeMode}
                />
                <Box bgColor={contentBgColor} flex={1} px={4} py={5}>
                    {children}
                </Box>
                <Footer />
            </Flex>
        </>
    )
})

export { AppContainer }
